import { IAuthenticationResult } from "../../model/IUserLoginEvent";

export class StoredAuthRemoveAction {
    static readonly type = "[StoredAuth] User Logout";
    constructor() {}
}

export class StoredAuthSetAction {
    static readonly type = "[StoredAuth] Set Auth Token";
    constructor(public payload: IAuthenticationResult) {}
}
export class StoredAuthUserRefreshTokenAction {
    static readonly type = "[StoredAuth] Refresh Token";

    constructor() {}
}
